export default "__VITE_ASSET__BLwmujer__"